import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton, ModuleSecondaryButton } from "@client/content/modules/Button";
import { OrderSummary } from "@client/content/modules/OrderConfirmation/Content/component";
import { isDummyOrder } from "@client/content/modules/OrderConfirmation/lib";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import Modal from "@client/controls/Modal/container";
import { IconType, Status } from "@client/types";
import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import AddCommentModal from "../../OrderConfirmation/Content/AddCommentModal/container";
import api from "../api";
import { type MemberOrders } from "../types";
import "./style.less";

export type MapProps = RootContainerProps & {
  apiInfo: ModuleApiInfo;
  isEditMode: boolean;
  detail: MemberOrders.ItemDetail | null;

  isVisible: boolean;
  noImageUrl: string;
  status: string;
};

export type ActionProps = {
  onClose: () => void;
  onClickAddComment: () => void;
};

export type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  const [isDownloading, setIsDownloading] = React.useState(false);

  const download = React.useCallback(async () => {
    if (!props.detail || isDummyOrder(props.detail.order.orderId)) return;

    setIsDownloading(true);
    try {
      await api.downloadPdf(props.apiInfo, props.detail.order.orderId);
    } finally {
      setIsDownloading(false);
    }
  }, [props.apiInfo, props.detail?.order.orderId]);

  return (
    <Modal
      className="wsc_member_order_detail"
      hasBackdrop
      isAdminColor={false}
      isDraggable={false}
      isCentered
      isVisible={props.isVisible}
      isLoading={props.status === Status.Loading}
      onClose={props.onClose}
      width={1200}
    >
      <Modal.Header title={i18n.orderDetails} />
      <Modal.Body>
        {props.detail?.order && (
          <div className="content">
            <OrderSummary
              isEditMode={props.isEditMode}
              noImageUrl={props.noImageUrl}
              orderSummary={props.detail}
              actions={
                <>
                  <div className="buttons">
                    <div
                      {...getTooltipAttributes(
                        props.detail.order.minOrderStatusKey === "Fulfilled" ? i18n.infoAddCommentDisabled : ""
                      )}
                    >
                      <ModuleSecondaryButton
                        {...getRootContainerProps(props)}
                        onClick={props.onClickAddComment}
                        icon={IconType.Comments}
                        caption={i18n.addComment}
                        isDisabled={props.detail.order.minOrderStatusKey === "Fulfilled"}
                      />
                    </div>

                    <ModuleButton
                      {...getRootContainerProps(props)}
                      isDisabled={isDownloading}
                      onClick={download}
                      caption={i18n.downloadInvoice}
                    />
                  </div>
                </>
              }
            />

            <AddCommentModal {...getRootContainerProps(props)} isModal={true} detail={props.detail} />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
